import api from '@/api/api'
import router from '@/router/index'
import compradores from '@/store/compradores/store'

export default {
  namespaced: true,
  state: {
    autoSaveDocu: false
  },
  modules: {
    compradores
  },
  mutations: {
    setAutoSaveMutation (state, payload) {
      state.autoSaveDocu = payload
    }
  },
  actions: {
    setAutoSave ({ commit }, value) {
      commit('setAutoSaveMutation', value)
    },
    insertarDocumentoComprador ({ dispatch }, {id, compradorId, documento}) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.set('jsondata', JSON.stringify({
          parametros: {
            id,
            compradorId
          }
        }))
        if (documento.file != null) {
          formData.append('documento[file]', documento.file)
        }
        if (documento.descripcionDocumento != null) {
          formData.set('documento[descripcionDocumento]', documento.descripcionDocumento)
        }
        formData.set('documento[validado]', documento.validado)
        formData.set('documento[carpetaId]', documento.carpetaId)
        formData.set('documento[extension]', documento.extension)
        formData.set('documento[mime]', documento.mime)
        formData.set('documento[nombre]', documento.nombre)
        api.post('/documentacion/insertar_documento_comprador', formData)
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    eliminarDocumentosRollback ({ dispatch }, {documentos}) {
      return new Promise((resolve, reject) => {
        api.post('/documentacion/eliminar_documentos_rollback', {
          jsondata: JSON.stringify({
            parametros: {
              documentos
            }
          })
        })
        .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarDocumentacion ({ dispatch }, {id, compradores, completado, simplificada}) {
      return new Promise((resolve, reject) => {
        api.post('/documentacion/modificar_documentacion', {
          jsondata: JSON.stringify({
            parametros: {
              id,
              compradores,
              completado, 
              simplificada
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    validarDocumentacion ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/validacionDocumentacion/validar_documentacion_kyc', {
          jsondata: JSON.stringify({
            parametros: {
              id: obj.id,
              validacionDocumentacion: obj.validacionDocumentacion,
              validacionKyc: obj.validacionKyc,
              titularId: obj.titularId,
              compradores: obj.compradores
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    firmarContratoKyc ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/documentacion/firmar_contrato_kyc', {
          jsondata: JSON.stringify({
            parametros: obj
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getAutoSave (state) {
      return state.autoSaveDocu
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/documentacion/store.js